import axios from "axios";
import { GET, POST } from '../_helpers/Fetch';
import { EmailNotificationApiUrl } from '../_constants/EmailNotificationAPI';
import { UrlFilterHelper } from "../_helpers/UrlFilterHelper";

export const EmailNotificationApi = {
    GetEmailNotificationServices,
    UpdateEmailNotificationEvent,
    GetEmailNotificationEvent,
    GetUnselectedInternalEmailNotificationUsers,
    GetPagedSelectedEmailNotificationUsers,
    AddEmailNotificationUser,
    DeleteEmailNotificationUser,
    GetEmailNotificationUsersByService,
    UpdateEmailNotificationUserFrequencies,
    GetAllVssClientEmailNotification,
    DeleteSelectedVssClientsEmailNotification,
    SaveSelectedVssClientsEmailNotification,
    ExportEmailUserPreference
};

// Admin Management

async function GetEmailNotificationServices() {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_SERVICE_GET_LIST;
    return axios.get(url); // Returns: PagedResultDto<EmailNotificationServiceDto>
}

async function UpdateEmailNotificationEvent(id, emailNotificationEventDto) {
    var emailNotificationEventUpdateDto = {
        "frequency": emailNotificationEventDto.frequency,
        "userGroupName": emailNotificationEventDto.userGroupName
    }
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_EVENT_UPDATE;
    return await axios.post(url + id, emailNotificationEventUpdateDto);
}

async function GetEmailNotificationEvent(id) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_EVENT_GET + id;
    return axios.get(url);
}

async function DeleteEmailNotificationUser(id) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USER_DELETE;
    return axios.post(url + id);
  }

async function AddEmailNotificationUser(EmailNotificationUserDto) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USER_CREATE;
    return axios.post(url, EmailNotificationUserDto); // Returns: EmailNotificationUserDto
  }

async function GetUnselectedInternalEmailNotificationUsers(skipCount, sorting, dsc, size, searchfilter, eventId) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USER_GET_UNSELECTEDINTERNALUSER;
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, searchfilter, sorting, dsc, size);
    if (eventId != null) {
        url += "&eventId=" + eventId;
    }
    return axios.get(url); // Returns: PagedResultDto<EmailNotificationUserUnselectedDto>
}

async function GetPagedSelectedEmailNotificationUsers(skipCount, sorting, dsc, size, searchfilter, eventId) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USER_GET_SELECTEDUSERS;
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, searchfilter, sorting, dsc, size);
    if (eventId != null) {
        url += "&eventId=" + eventId;
    }
    return axios.get(url); // Returns: PagedResultDto<EmailNotificationUserSelectedDto>
}

async function ExportEmailUserPreference(serviceId) {
    const url = `${EmailNotificationApiUrl.EMAIL_NOTIFICATION_EXPORT}${serviceId}`;
    return axios.get(url, { responseType: "blob" }); // Returns: File
}

// User Settings

async function GetEmailNotificationUsersByService(id) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USERS_BY_SERVICES;
    return axios.get(url); // Returns: ICollection<EmailNotificationUserSettingsServiceDto>
}

async function UpdateEmailNotificationUserFrequencies(updateEmailNotificationUserSettingsServiceDto) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_USERS_UPDATE_FREQUENCIES
    return axios.post(url, updateEmailNotificationUserSettingsServiceDto); // Returns: ApiResponse<ICollection<EmailNotificationUserSettingsServiceDto>>
}

// Selected VSS Clients for Visa Staff

async function GetAllVssClientEmailNotification(requestDto) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_FULL_SELECTED_VSS_CLIENT_GET;
    return axios.get(url, { params: requestDto }); // Returns: List<EmailNotificationFullSelectedVSSClientDto>
}

async function DeleteSelectedVssClientsEmailNotification(requestDto) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_SELECTED_VSS_CLIENTS_DELETE;
    return axios.post(url, requestDto); // Returns: IActionResult
}

async function SaveSelectedVssClientsEmailNotification(requestDto) {
    var url = EmailNotificationApiUrl.EMAIL_NOTIFICATION_SELECTED_VSS_CLIENT_SAVE;
    return axios.post(url, requestDto); // Returns: IActionResult
}
